import { zodResolver } from "@hookform/resolvers/zod";
import LoadingButton from "@mui/lab/LoadingButton";
import { Stack, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import TextField from "@mui/material/TextField";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import { Controller, useForm } from "react-hook-form";

import { LoginInterface } from "./Login";
import { loginResolver } from "./login.resolvers";

import { loginUser } from "@/api";
import { useAppDispatch } from "@/redux";
import { setJwtTokenValue } from "@/redux/reducers/auth";


export const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const { control, handleSubmit } = useForm<LoginInterface>({
    mode: "onBlur",
    resolver: zodResolver(loginResolver),
  });

  const { mutate, isPending } =
    useMutation({
      mutationFn: async (data: LoginInterface) => loginUser(data),
      onSuccess: (response) => {
        dispatch(setJwtTokenValue({ jwtToken: response?.data?.token }));
      },
    });

  const submit = (data: LoginInterface) => {
    mutate(data);
  }

  return (
    <Box
      sx={{
        margin: "0 auto",
        width: "40vw",
        marginTop: "20vh",
      }}
    >
      <form onSubmit={handleSubmit(submit)}>
        <Stack direction="column" spacing={2}>
          <Typography
            variant="h4"
            align="center"
          >
            Time Tracker
          </Typography>
          <Controller
            control={control}
            name="email"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="Email"
                placeholder="Email"
                error={Boolean(error?.message)}
                helperText={error?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="password"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="Password"
                placeholder="Password"
                type="password"
                error={Boolean(error?.message)}
                helperText={error?.message}
              />
            )}
          />
          <LoadingButton
            size="medium"
            variant="contained"
            loadingPosition="start"
            type="submit"
            color="primary"
            loading={isPending}
          >
            Submit
          </LoadingButton>
        </Stack>
      </form>
    </Box>
  );
};
